module.exports = __webpack_public_path__ + "static/assets/4201a0f7fd81c6df87d772b10d2e4707.svg";